export default "__VITE_ASSET__b4891d4e__"